import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class XevprmMessageEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("Local Number", ListDataColumn.TEXT, "localnumber"),
                new ListColumn("Message Number", ListDataColumn.TEXT, "messagenumber"),
                new ListColumn("Sender ID", ListDataColumn.TEXT, "senderid"),
                new ListColumn("Sender Name", ListDataColumn.TEXT, "sendername"),
                new ListColumn("Message Date", ListDataColumn.TEXT, "messagedate"),
                new ListColumn("Message Receive Date", ListDataColumn.DATETIME,'messagereceivedate'),
                new ListColumn("Message Ack Date", ListDataColumn.DATETIME,'ackdate'),
            ];

            const itemFinderTreeColumns=[
                new ListColumn("Local Number", ListDataColumn.TEXT, "localnumber"),
                new ListColumn("Message Number", ListDataColumn.TEXT, "messagenumber"),
                new ListColumn("Sender ID", ListDataColumn.TEXT, "senderid"),
                new ListColumn("Sender Name", ListDataColumn.TEXT, "sendername"),
                new ListColumn("Message Date", ListDataColumn.TEXT, "messagedate"),
                new ListColumn("Message Receive Date", ListDataColumn.DATETIME,'messagereceivedate'),
                new ListColumn("Message Ack Date", ListDataColumn.DATETIME,'ackdate'),
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}